import http from './http';

export default {
  // 获取举办方配置
  getOrganizerConfig(organizerId) {
    return http.get(`/organizer/${organizerId}/config`);
  },
  
  // 更新举办方配置
  updateOrganizerConfig(organizerId, data) {
    return http.put(`/organizer/${organizerId}/config`, data);
  },
  
  // 更新基础信息
  updateBasicInfo(organizerId, data) {
    return http.put(`/organizer/${organizerId}/basic`, data);
  },
  
  // 更新主题配置
  updateThemeConfig(organizerId, data) {
    return http.put(`/organizer/${organizerId}/theme`, data);
  },
  
  // 预览主题
  previewTheme(organizerId, data) {
    return http.post(`/organizer/${organizerId}/theme/preview`, data);
  },
  
  // 更新登录配置
  updateLoginConfig(organizerId, data) {
    return http.put(`/organizer/${organizerId}/login`, data);
  },
  
  // 更新考试配置
  updateExamConfig(organizerId, data) {
    return http.put(`/organizer/${organizerId}/exam`, data);
  },
  
  // 更新通知配置
  updateNotificationConfig(organizerId, data) {
    return http.put(`/organizer/${organizerId}/notification`, data);
  },
  
  // 更新阅卷配置
  updateGradingConfig(organizerId, data) {
    return http.put(`/organizer/${organizerId}/grading`, data);
  },
  
  // 更新功能配置
  updateFeatureConfig(organizerId, data) {
    return http.put(`/organizer/${organizerId}/feature`, data);
  },
  
  // 更新限制配置
  updateLimitsConfig(organizerId, data) {
    return http.put(`/organizer/${organizerId}/limits`, data);
  },
  
  // 上传Logo
  uploadLogo(organizerId, file) {
    const formData = new FormData();
    formData.append('logo', file);
    return http.upload(`/organizer/${organizerId}/logo`, formData);
  },
  
  // 获取主题预设
  getThemePresets() {
    return http.get('/organizer/theme/presets');
  },
  
  // 导出配置
  exportConfig(organizerId) {
    return http.get(`/organizer/${organizerId}/config/export`, {}, {
      responseType: 'blob'
    });
  },
  
  // 导入配置
  importConfig(organizerId, file) {
    const formData = new FormData();
    formData.append('config', file);
    return http.upload(`/organizer/${organizerId}/config/import`, formData);
  },
  
  // 重置配置
  resetConfig(organizerId, type) {
    return http.post(`/organizer/${organizerId}/config/reset`, { type });
  }
};
